import React from "react";

const PageShell = ({ children }) => (
  <div className="page">{children}</div>
);

export default PageShell;
